module.exports = __webpack_public_path__ + "static/media/Round1.872290de.jpg";